import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { remarkSubscript } from '@/lib/remarkSubscript';
import { MarkdownSection } from '@/types';

interface MarkdownRendererProps {
  section: MarkdownSection;
}

export function MarkdownRenderer({ section }: MarkdownRendererProps) {
  return (
    <div className="p-6 bg-card border border-border rounded-lg">
      <div className="prose prose-slate dark:prose-invert max-w-none">
        <ReactMarkdown remarkPlugins={[remarkGfm, remarkSubscript]}>
          {section.data.content}
        </ReactMarkdown>
      </div>
    </div>
  );
}
